module.exports = __webpack_public_path__ + "static/banner-e00e0b99c22e131d6f49a71df0dad12b.png";